import { render, staticRenderFns } from "./Factsheet.vue?vue&type=template&id=66b17cbe"
import script from "./Factsheet.vue?vue&type=script&lang=js"
export * from "./Factsheet.vue?vue&type=script&lang=js"
import style0 from "./Factsheet.vue?vue&type=style&index=0&id=66b17cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports